module.exports = __webpack_public_path__ + "img/phone_calling.20b6860e.gif";